'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var Icons$AlgoVis = require("./Icons.bs.js");
var Utils$AlgoVis = require("./Utils.bs.js");
var LoadBalancing$AlgoVis = require("./LoadBalancing.bs.js");

function Components$Job(Props) {
  var size = Props.size;
  var isHighlighted = Props.isHighlighted;
  return React.createElement("div", {
              "aria-label": "job of size " + String(size),
              className: "job tube" + (
                isHighlighted ? " tube--primary" : ""
              ),
              style: {
                flexBasis: "0",
                flexGrow: String(size)
              }
            }, React.createElement("svg", {
                  className: "job__content",
                  role: "presentation",
                  viewBox: "0 -4 80 48"
                }, React.createElement("text", {
                      role: "presentation",
                      dominantBaseline: "middle",
                      textAnchor: "middle",
                      x: "50%",
                      y: "50%"
                    }, size)));
}

var Job = {
  make: Components$Job
};

function Components$BarPlot(Props) {
  var machines = Props.machines;
  var makespan = machines !== undefined ? LoadBalancing$AlgoVis.getMakespan(machines) : undefined;
  return React.createElement("div", {
              "aria-label": "Visualization of the computed solution to the load balancing problem",
              className: "barplot",
              role: "figure"
            }, machines !== undefined && makespan !== undefined ? $$Array.map((function (machine) {
                      var height = machine.load / makespan * 100;
                      var hasMaxMakespan = machine.load === makespan;
                      return React.createElement("div", {
                                  key: String(machine.id),
                                  "aria-label": "machine",
                                  className: "machine",
                                  style: {
                                    height: height.toString() + "%"
                                  }
                                }, $$Array.init(List.length(machine.jobs), (function (i) {
                                        return React.createElement(Components$Job, {
                                                    size: List.nth(machine.jobs, i),
                                                    isHighlighted: hasMaxMakespan,
                                                    key: String(i)
                                                  });
                                      })));
                    }), machines) : null);
}

var BarPlot = {
  make: Components$BarPlot
};

function Components$NumberInput(Props) {
  var value = Props.value;
  var id = Props.id;
  var ariaLabelledby = Props.ariaLabelledby;
  var min = Props.min;
  var max = Props.max;
  var onChange = Props.onChange;
  return React.createElement("div", {
              className: "number-input tube tube--bottom",
              role: "presentation"
            }, React.createElement("input", {
                  "aria-labelledby": Utils$AlgoVis.getOptionValue(ariaLabelledby, ""),
                  id: Utils$AlgoVis.getOptionValue(id, ""),
                  max: String(max),
                  min: String(min),
                  type: "number",
                  value: String(value),
                  onChange: (function ($$event) {
                      var newValue = $$event.target.value;
                      var intValue;
                      try {
                        intValue = Caml_format.caml_int_of_string(newValue);
                      }
                      catch (exn){
                        return ;
                      }
                      var minValue = Utils$AlgoVis.getOptionValue(min, Pervasives.min_int);
                      var maxValue = Utils$AlgoVis.getOptionValue(max, Pervasives.max_int);
                      if (minValue <= intValue && intValue <= maxValue) {
                        return Curry._1(onChange, intValue);
                      }
                      
                    })
                }), React.createElement("div", {
                  "aria-hidden": true,
                  className: "number-input__buttons"
                }, React.createElement("button", {
                      className: "number-input__button",
                      tabIndex: -1,
                      type: "button",
                      onClick: (function (param) {
                          if (max !== undefined && value >= max) {
                            return ;
                          } else {
                            return Curry._1(onChange, value + 1 | 0);
                          }
                        })
                    }, React.createElement("svg", {
                          role: "presentation",
                          viewBox: "0 0 14 14"
                        }, React.createElement("polygon", {
                              points: "6,6 2.54,12 9.46,12"
                            }))), React.createElement("button", {
                      className: "number-input__button",
                      tabIndex: -1,
                      type: "button",
                      onClick: (function (param) {
                          if (min !== undefined && value <= min) {
                            return ;
                          } else {
                            return Curry._1(onChange, value - 1 | 0);
                          }
                        })
                    }, React.createElement("svg", {
                          role: "presentation",
                          viewBox: "0 0 14 14"
                        }, React.createElement("polygon", {
                              points: "6,8 2.54,2 9.46,2"
                            })))));
}

var NumberInput = {
  make: Components$NumberInput
};

function Components$FloatNumberInput(Props) {
  var value = Props.value;
  var id = Props.id;
  var ariaLabelledby = Props.ariaLabelledby;
  var min = Props.min;
  var max = Props.max;
  var step = Props.step;
  var onChange = Props.onChange;
  return React.createElement("div", {
              className: "number-input tube tube--bottom",
              role: "presentation"
            }, React.createElement("input", {
                  "aria-labelledby": Utils$AlgoVis.getOptionValue(ariaLabelledby, ""),
                  id: Utils$AlgoVis.getOptionValue(id, ""),
                  max: String(max),
                  min: String(min),
                  step: Utils$AlgoVis.getOptionValue(step, 1.0),
                  type: "number",
                  value: String(value),
                  onChange: (function ($$event) {
                      var newValue = $$event.target.value;
                      var floatValue;
                      try {
                        floatValue = Caml_format.caml_float_of_string(newValue);
                      }
                      catch (exn){
                        return ;
                      }
                      var minValue = Utils$AlgoVis.getOptionValue(min, Pervasives.min_float);
                      var maxValue = Utils$AlgoVis.getOptionValue(max, Pervasives.max_float);
                      if (minValue <= floatValue && floatValue <= maxValue) {
                        return Curry._1(onChange, floatValue);
                      }
                      
                    })
                }), React.createElement("div", {
                  "aria-hidden": true,
                  className: "number-input__buttons"
                }, React.createElement("button", {
                      className: "number-input__button",
                      tabIndex: -1,
                      type: "button",
                      onClick: (function (param) {
                          if (max !== undefined) {
                            if (value < max) {
                              return Curry._1(onChange, (value * 10.0 + 1.0) / 10.0);
                            } else {
                              return ;
                            }
                          } else {
                            return Curry._1(onChange, (value * 10.0 + 1.0) / 10.0);
                          }
                        })
                    }, React.createElement("svg", {
                          role: "presentation",
                          viewBox: "0 0 14 14"
                        }, React.createElement("polygon", {
                              points: "6,6 2.54,12 9.46,12"
                            }))), React.createElement("button", {
                      className: "number-input__button",
                      tabIndex: -1,
                      type: "button",
                      onClick: (function (param) {
                          if (min !== undefined) {
                            if (value > min) {
                              return Curry._1(onChange, (value * 10.0 - 1.0) / 10.0);
                            } else {
                              return ;
                            }
                          } else {
                            return Curry._1(onChange, (value * 10.0 - 1.0) / 10.0);
                          }
                        })
                    }, React.createElement("svg", {
                          role: "presentation",
                          viewBox: "0 0 14 14"
                        }, React.createElement("polygon", {
                              points: "6,8 2.54,2 9.46,2"
                            })))));
}

var FloatNumberInput = {
  make: Components$FloatNumberInput
};

function Components$MultiNumberInput(Props) {
  var value = Props.value;
  var id = Props.id;
  var ariaLabelledby = Props.ariaLabelledby;
  var min = Props.min;
  var max = Props.max;
  var onChange = Props.onChange;
  return React.createElement(React.Fragment, undefined, $$Array.init(value.length, (function (i) {
                    return React.createElement(Components$NumberInput, {
                                value: Caml_array.caml_array_get(value, i),
                                id: i === 0 ? Utils$AlgoVis.getOptionValue(id, "") : "",
                                ariaLabelledby: ariaLabelledby,
                                min: min,
                                max: max,
                                onChange: (function (changedValue) {
                                    var newValue = $$Array.copy(value);
                                    Caml_array.caml_array_set(newValue, i, changedValue);
                                    return Curry._1(onChange, newValue);
                                  }),
                                key: String(i)
                              });
                  })));
}

var MultiNumberInput = {
  make: Components$MultiNumberInput
};

function Components$Select(Props) {
  var children = Props.children;
  var id = Props.id;
  var value = Props.value;
  var onChange = Props.onChange;
  return React.createElement("div", {
              className: "select tube tube--bottom",
              role: "presentation"
            }, React.createElement("select", {
                  id: id,
                  value: value,
                  onChange: onChange
                }, children), React.createElement("svg", {
                  className: "select__arrow",
                  role: "presentation",
                  viewBox: "0 0 12 12"
                }, React.createElement("polygon", {
                      points: "1,3 11,3 6,11.66"
                    })));
}

var Select = {
  make: Components$Select
};

function Components$ColorModeToggle(Props) {
  var match = React.useState(function () {
        return window.document.documentElement.style.getPropertyValue("--initial-color-mode");
      });
  var rawSetColorMode = match[1];
  var colorMode = match[0];
  return React.createElement("button", {
              className: "dark-mode",
              title: colorMode === "light" ? "Activate dark mode" : "Activate light mode",
              type: "button",
              onClick: (function (param) {
                  var newColorMode = colorMode === "light" ? "dark" : "light";
                  Curry._1(rawSetColorMode, (function (param) {
                          return newColorMode;
                        }));
                  localStorage.setItem("color-mode", newColorMode);
                  if (!(colorMode === "dark" && newColorMode === "light" || colorMode === "light" && newColorMode === "dark")) {
                    return ;
                  }
                  var computedStyle = getComputedStyle(window.document.documentElement);
                  var light = computedStyle.getPropertyValue("--color-light");
                  var dark = computedStyle.getPropertyValue("--color-dark");
                  window.document.documentElement.style.setProperty("--color-light", dark);
                  window.document.documentElement.style.setProperty("--color-dark", light);
                  
                })
            }, colorMode === "light" ? React.createElement(Icons$AlgoVis.Sun.make, {}) : React.createElement(Icons$AlgoVis.Moon.make, {}));
}

var ColorModeToggle = {
  make: Components$ColorModeToggle
};

exports.Job = Job;
exports.BarPlot = BarPlot;
exports.NumberInput = NumberInput;
exports.FloatNumberInput = FloatNumberInput;
exports.MultiNumberInput = MultiNumberInput;
exports.Select = Select;
exports.ColorModeToggle = ColorModeToggle;
/* react Not a pure module */
